function Notice() {
    return window.matchMedia('(min-width: 820px) and (orientation: landscape)').matches ? (
        <section className="Notice">
            <div className="Notice-text">
                <p className="light">This app is not optimized for Desktop devices. </p>
                <p>Please visit this site on your phone.</p>
            </div>
        </section>
    ) : (
        <></>
    );
}

export default Notice;
